import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OptimizationPopupComponent } from './optimization-popup.component';
import { MatIconModule } from "@angular/material/icon";
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MaterialModule } from 'src/app/shared/material/material.module';



@NgModule({
  declarations: [
    OptimizationPopupComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    FormsModule,
  MaterialModule
],
  exports:[
    OptimizationPopupComponent
  ]
})
export class OptimizationPopupModule { }
